import { Children, type ReactNode } from 'react';

export const getNodeTextLength = (node: ReactNode): number =>
  Children.toArray(node).reduce<number>(
    (length, child) =>
      length +
      (typeof child === 'string' || typeof child === 'number' ? String(child).trim().length : 0),
    0,
  );

/**
 * When loading text is at least this fraction shorter than the idle children, spreading the spinner
 * and text across the full width (justify-evenly) leaves an awkward gap, so we center them instead.
 */
const SHORTER_LOADING_TEXT_THRESHOLD = 0.25;

export const isLoadingTextMuchShorter = (children: ReactNode, loadingText: ReactNode): boolean => {
  const childrenTextLength = getNodeTextLength(children);
  const loadingTextLength = getNodeTextLength(loadingText);

  return (
    childrenTextLength > 0 &&
    loadingTextLength < childrenTextLength * (1 - SHORTER_LOADING_TEXT_THRESHOLD)
  );
};
